// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".badge[data-v-525775ee]{display:grid;justify-items:center;font-size:.875rem;line-height:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
